export const Leaf = ({ attributes, children, leaf }) => {
  if (!attributes.style) {
    attributes.style = {};
  }
  if (leaf.fontSize) {
    attributes.style.fontSize = parseInt(leaf.fontSize);
  }
  if (leaf.color) {
    attributes.style.color = leaf.color;
  }
  if (leaf.background) {
    attributes.style.background = leaf.background;
  }
  if (leaf.fontFamily) {
    attributes.style.fontFamily = leaf.fontFamily;
  }
  if (leaf.bold) {
    children = <strong {...attributes}>{children}</strong>;
  }

  if (leaf.code) {
    children = <code {...attributes}>{children}</code>;
  }

  if (leaf.italic) {
    children = <em {...attributes}>{children}</em>;
  }
  if (leaf.strikethrough) {
    children = <s {...attributes}>{children}</s>;
  }

  if (leaf.underline) {
    children = <u {...attributes}>{children}</u>;
  }
  return <span {...attributes}>{children}</span>;
};
